import { apiFetch } from "@/shared/api/http";

export interface DependenteGamificacao { alunoId:string; nome:string; treinos:number; frequenciaPercentual:number; sequenciaAtual:number; desafiosAtivos:number; desafiosConcluidos:number; }
export interface ResponsavelGamificacaoResumo { periodo:string; dependentes:DependenteGamificacao[]; }
export function obterGamificacaoResponsavel(){ return apiFetch<ResponsavelGamificacaoResumo>("/api/app/gamificacao/responsavel/resumo"); }
